module.exports = __webpack_public_path__ + "ff0ed1c03cab26a26256f92730b0e997.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/avenir-next-regular.ttf
// module id = 1281
// module chunks = 0